import { render, staticRenderFns } from "./Motifs.vue?vue&type=template&id=607f8d6a"
import script from "./Motifs.vue?vue&type=script&lang=js"
export * from "./Motifs.vue?vue&type=script&lang=js"
import style0 from "./Motifs.vue?vue&type=style&index=0&id=607f8d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports